module.exports = __webpack_public_path__ + "img/img15.21425145.svg";